import SubTabSection from '../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection';
import SubTabParent from '../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent';


function LaunchCastingMeetingTab(props) {

  return (
    <SubTabParent passData={props}>
      <SubTabSection title='Launch ClashBot' description='ClashBot is a system to help enforce your casting policy. It identifies auditionees wanted by multiple projects in a single season.'>
        <a href={window.location.origin + '/clashbot/' + props.userData.active_organisation_id} target='_blank' rel='noreferrer'>
          <button style={{backgroundColor: props.accentColour}}>Launch ClashBot</button>
        </a>
      </SubTabSection>
    </SubTabParent>
  )

}

export default LaunchCastingMeetingTab;